import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export const SubmenuPage = () => {
  const { setBottomNavigation } = useThemeStore((state) => state);
  useEffect(() => {
    setBottomNavigation("hidden");
  }, [setBottomNavigation]);
  return (
    <>
      <BaseLayout>
        <Header />
        {/* <div
          className="tw-bg-background-200 tw-rounded-t-[1rem]"
          style={{
            position: "absolute",
            width: "100%",
            height: "16px",
            top: "70px",
          }}
        >
        </div> */}
        <Outlet />
      </BaseLayout>
    </>
  );
};
